import Logo from '@/assets/logo.svg?react';
const Header = () => {
    return (
        <div className="header-wrap">
            <a href="https://cloud.baidu.com/" className="logo-wrap">
                <Logo />
            </a>
        </div>
    );
};
export default Header;
